import { useEffect, useState } from "react";
import styled from "styled-components";
import BookService from "../../services/BookService";
import placeholderImage from "../../assets/logo.png";
import BookDetail from "./BookDetail";
import { Overlay, ModalCloseButton } from "../CommonComponents/DataCard";
import Button from "../CommonComponents/Button";

const Card = styled.div`
  display: flex;
  width: 600px;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 16px;
  cursor: pointer;
  background-color: ${({ theme }) => theme.colors.card};
  box-shadow: 0 4px 16px ${({ theme }) => theme.colors.shadow};
  transition: transform 0.2s, box-shadow 0.2s;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 24px ${({ theme }) => theme.colors.shadow};
  }
`;

const Thumbnail = styled.img`
  flex: 0 0 150px;
  width: 150px;
  height: 100%;
  object-fit: cover;
`;

const Info = styled.div`
  flex: 1;
  padding: 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  h3 {
    margin: 0 0 8px 0;
  }

  p {
    margin: 0 0 4px 0;
  }
`;






function BookCard({ book, user, onCancelReservation }) {
  const [thumbnail, setThumbnail] = useState(null);
  const [selectedBookId, setSelectedBookId] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);



  useEffect(() => {
    setCurrentUser(user)
    const loadThumbnail = async () => {
      try {
        const thumbUrl = await BookService.getBookThumbnail(book.id);
        setThumbnail(thumbUrl || placeholderImage);
      } catch (error) {
        setThumbnail(placeholderImage);
      }
    };
    loadThumbnail();
  }, [book.id]);

  return (
    <>
      <Card>
        <div onClick={() => setSelectedBookId(book.id)} style={{ display: "flex", flex: 1 }}>
          <Thumbnail src={thumbnail || placeholderImage} alt={book.name} />
          <Info>
            <div>
              <h3>{book.name}</h3>
              <p><strong>Godina izdavanja:</strong> {book.yearOfPublishment ? new Date(book.yearOfPublishment).getFullYear() : "Nepoznato"}</p>
              <p><strong>Mjesto izdavanja:</strong> {book.placeOfPublishment || "Nepoznato"}</p>
              <p style={{ wordWrap: "break-word", overflowWrap: "break-word", lineHeight: "1.5", margin: 0 }}>
                <strong>Kratki opis:</strong>{" "}
                {book.shortDescription
                  ? (book.shortDescription.length > 40 ? book.shortDescription.slice(0, 40) + "…" : book.shortDescription)
                  : "Nepoznato"}
              </p>

              {book.note && <p><strong>Bilješke:</strong> {book.note}</p>}
              <p>
                <strong>{book.authors?.length > 1 ? "Autori:" : "Autor:"}</strong>{" "}
                {book.authors?.length > 0
                  ? book.authors.map(a => `${a.name} ${a.surname}`).join(", ")
                  : "Nepoznato"}
              </p>
              <p>
                <strong>Dostupnost:</strong>{" "}
                <span
                  style={{
                    color: book.available > 0 ? "green" : "red",
                  }}
                >
                  {book.available > 0 ? "Dostupno" : "Nedostupno"}
                </span>
              </p>

            </div>
          </Info>
        </div>
        {onCancelReservation && (
          <div style={{ padding: "12px", display: "flex", alignItems: "center" }}>
            <Button
              tekst="Otkaži rezervaciju"
              akcija={(e) => {
                e.stopPropagation();
                onCancelReservation(book.id);
              }}
            />
          </div>
        )}
      </Card>

      {selectedBookId && (
        <Overlay onClick={() => setSelectedBookId(null)} style={{ alignItems: "flex-start", padding: "2rem 1rem", overflowY: "auto", boxSizing: "border-box" }}>
          <div onClick={(e) => e.stopPropagation()} style={{ position: "relative", width: "fit-content" }}>
            <ModalCloseButton onClick={() => setSelectedBookId(null)} title="Zatvori" style={{ position: "absolute", top: "0.75rem", right: "0.75rem", zIndex: 1 }}>×</ModalCloseButton>
            <BookDetail bookId={selectedBookId} user={currentUser} />
          </div>
        </Overlay>
      )}
    </>
  );
}

export default BookCard;
